module.exports = __webpack_public_path__ + "static/img/8.0bed401.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/1/sp/8.png
// module id = h9Ek
// module chunks = 0